module.exports = __webpack_public_path__ + "static/media/download-white.22781f7c.svg";